import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { DEFAULT_CURRENCY_CODE, EnvironmentProviders, LOCALE_ID, makeEnvironmentProviders } from '@angular/core';
import { CookiesService } from '@shared/cookies/cookies.service';
import { MomentService } from '@shared/moment/services/moment.service';
import { ENGINE_LOCALE_ID, EngineCultureService } from './services/culture.service';
import { EngineDateParser } from './services/date-parser.service';

export function provideEngineCulture(): EnvironmentProviders {
  return makeEnvironmentProviders([
    EngineCultureService,
    { provide: LOCALE_ID, useValue: ENGINE_LOCALE_ID },
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useFactory: (cultureService: EngineCultureService, momentService: MomentService) => {
        let timezone = 'UTC';
        try {
          timezone = cultureService.cultureSettings?.ianaTimeZone ?? timezone;
        } catch (_) {}

        const offsetMinutes = momentService.getTimezoneOffset(timezone);
        const offsetHours = offsetMinutes / 60;
        const utcString = `UTC${offsetHours >= 0 ? '+' : ''}${offsetHours}`;

        return { timezone: utcString };
      },
      deps: [EngineCultureService, MomentService, CookiesService],
    },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useFactory: (cultureService: EngineCultureService) => {
        let currency = '$';
        try {
          currency = cultureService.localeData[16] ?? currency;
        } catch (_) {}
        return currency;
      },
      deps: [EngineCultureService, CookiesService],
    },
    EngineDateParser,
  ]);
}
